import React from 'react';
import { BsFacebook } from 'react-icons/bs';
import { Link } from 'react-router-dom';
const Footer = () => {
  return (
    <footer>
      <div className="container footer-container">
        <div>
          <h3>KWIECIŃSCY</h3>
          <p>NIP: 562 180 81 84</p>
          <p>REGON: 367849700</p>
          <p>KRS: 0000686009</p>
        </div>
        <div>
          <p>
            <b> Mapa strony:</b>
          </p>
          <p>
            <a>O nas</a>
          </p>
          <p>
            <a>Sklepy Firmowe</a>
          </p>
          <p>
            <a>Katalog Wędlin</a>
          </p>
          <p>
            <a>Sklep</a>
          </p>
          <p>
            <a>Oferta</a>
          </p>
        </div>
        <div>
          <p>
            <b> Kontakt: </b>
          </p>
          <p>ppuhkw@wp.pl</p>
          <p>52 302 0161</p>
          <p>881 210 836</p>
          <a
            target="_blank"
            href="https://www.facebook.com/KwiecinscyMasarnia/"
          >
            <BsFacebook className="text-white" />
          </a>
        </div>
        <div>
          <p>
            <b>Godziny otwarcia:</b>
          </p>
          <p>7:00 - 21:00</p>
          <p>od poniedziałku do piątku</p>
          <p>7:00 - 14:00</p>
          <p>w soboty</p>
        </div>
      </div>
      <section className="footer-copyright">
        <p>
          Copyright ©2024 Zakład Mięsny Kwiecińścy sp. Z o.o., All Rights
          Reserved.
        </p>
      </section>
    </footer>
  );
};

export default Footer;
